module.exports = __webpack_public_path__ + "static/media/reports.c86940a4.svg";